import NavLink from 'client/components/aria/NavLink/NavLink';
import Link from 'client/components/aria/Link/Link';
import PropTypes from 'prop-types';

const BreadcrumbItemContent = ({ item }) => {
    if (item.link) {
        return (
            <NavLink className="govuk-breadcrumbs__link" to={item.link} aria-current={item.ariaCurrent} data-testid={item.name + '.link.breadcrumb'}>
                {item.name}
            </NavLink>
        );
    }
    if (item.onClick) {
        return (
            <Link className="govuk-breadcrumbs__link" onClick={item.onClick} aria-current={item.ariaCurrent} data-testid={item.name + '.link.breadcrumb'}>
                {item.name}
            </Link>
        );
    }
    return (
        <span
            className="govuk-breadcrumbs__text"
            data-testid={item.name + '.item'}
            aria-current={item.ariaCurrent}
        >
            {item.name}
        </span>
    );
};

export const Breadcrumbs = ({ items }) => {
    return (
        <nav className="govuk-breadcrumbs" data-testid={'breadcrumb'}>
            <ol className="govuk-breadcrumbs__list">
                {items.map((item) => (
                    <li key={item.name} className="govuk-breadcrumbs__list-item" data-testid={item.name + '.breadcrumb'}>
                        <BreadcrumbItemContent item={item} />
                    </li>
                ))}
            </ol>
        </nav>
    );
};

Breadcrumbs.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            link: PropTypes.string,
            onClick: PropTypes.func,
            ariaCurrent: PropTypes.string
        })
    ).isRequired
};
